import { TextField } from '@material-ui/core';
import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react'
import { Autocomplete } from '@material-ui/lab';
import { fetchConToken } from '../../../helpers/fetch';

const BuscadorPractica = forwardRef(({ label, fieldsDisabled, cod, setCod, buscarTodas = false, errors, variant = "filled", margin }, ref) => {
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    resetValues: () => {
      setOptions([]);
    }
  }));

  useEffect(() => {
    let active = true;

    setLoading(true);

    if (inputValue === '') {
      setOptions(cod ? [cod] : []);
      setLoading(false);
      return undefined;
    }

    (async () => {
      const response = await fetchConToken(`NomencladorNacional?codigoNombre=${inputValue}&todas=${buscarTodas}`);
      const results = await response.json();
      if (active) {
        let newOptions = [];

        if (cod) {
          newOptions = [cod];
        }

        newOptions = [...newOptions, ...results];

        setOptions(newOptions);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
    };

  }, [cod, inputValue]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      disabled={fieldsDisabled}
      getOptionLabel={(option) => {
        return (`${option.codNom}-${option.desNom}`)
      }}
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={cod}
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        setCod(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      noOptionsText="No hay practicas"
      loadingText="Buscando..."
      loading={loading}
      {...errors}
      renderInput={(params) => (
        <TextField {...params} label={label} margin={margin} variant={variant} fullWidth />
      )}
    />
  )
}
)

export default BuscadorPractica
